module.exports = __webpack_public_path__ + "img/figure01.94c69b69.png";